import React from 'react';
import { NotFoundErrorPage } from '../../components/error-pages/not-found';

export const NotFoundPage: React.FC = () => <NotFoundErrorPage />;
